var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.717 42.9479C120.971 38.783 118.599 34.3889 114.434 33.1489C110.269 31.8954 105.875 34.2676 104.635 38.4325C104.028 40.4678 104.284 42.557 105.187 44.3092L102.316 53.9195C101.589 56.3321 102.977 58.9066 105.39 59.6209L107.465 60.2409C109.878 60.9688 112.452 59.5805 113.167 57.1678L116.038 47.5576C117.749 46.5871 119.111 44.9966 119.731 42.9613L119.717 42.9479Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.842 95.6544C114.871 95.6544 124.623 85.9025 124.623 73.8729C124.623 61.8433 114.871 52.0914 102.842 52.0914C90.8123 52.0914 81.0604 61.8433 81.0604 73.8729C81.0604 85.9025 90.8123 95.6544 102.842 95.6544Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.021 80.2235L86.4115 71.3628C80.8489 69.6982 74.99 72.8581 73.3254 78.4208L58.3207 128.561C56.656 134.124 59.816 139.983 65.3786 141.647L94.9877 150.508C100.55 152.173 106.409 149.013 108.074 143.45L123.079 93.3096C124.743 87.747 121.583 81.8881 116.021 80.2235Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.082 77.4538L79.5573 63.531C76.0415 62.4789 72.3384 64.4761 71.2862 67.992L70.7143 69.9031C69.6622 73.419 71.6594 77.1221 75.1753 78.1742L121.7 92.0969C125.216 93.1491 128.919 91.1518 129.971 87.636L130.543 85.7249C131.595 82.209 129.598 78.5059 126.082 77.4538Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.266 100.507L117.264 103.795",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.626 112.678L113.625 115.967",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9869 124.836L109.985 128.124",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3479 136.993L106.333 140.282",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirth);
export default __webpack_public_path__ + "static/media/birth.e6e03b97e41ba73cd85b0c08e1dd3049.svg";
export { ForwardRef as ReactComponent };